import { BASE_URL } from './base/config';

class Config {
}
Config.OK_CODE = '0';
Config.AXIOS_COF = 'application/json; charset=utf-8';
Config.baseUrl = BASE_URL;
export { Config };



// WEBPACK FOOTER //
// ./src/assets/common/config.js